<template>
<div class="col-12 mt-2">
	<label for="">Warehouse Aktif</label>
	<div v-if="listWarehouse.length > 0">
		<Accordion
			v-for="(warehouse, i) in listWarehouse"
			:key="i"
			:showArrow="true"
			:autoClose="false"
			:open="isOpen(warehouse, productInventory)"
			arrowPosition="left"
			:tooltip="'Pilih warehouse untuk mengatur stock'"
			:disabled="!(setting.enabled)"
			:class="{
				'product-cursor-disable': !setting.enabled
			}"
			@toggle-click="setProductInventory(warehouse)">
			<template #heading>
				<div class="row" style="width: 100%">
					<div class="col-sm-2">
						<div class="d-flex justify-content-between align-items-center">
							<div class="d-flex p-1 bg-gray rounded h-auto w-auto">
								<i class="warehouse__icon material-icons">warehouse</i>
							</div>
							<div class="ml-3">
								<span class="integration__title text-nowrap">
									{{ warehouse.warehouse_label }}
								</span>
							</div>
						</div>
					</div>
					<div style="z-index: 1" class=" col-sm-10">
						<div class="d-flex justify-content-end">
							<button
								v-tooltip="$t('Edit Warehouse')"
								class="btn bg-gray btn-light btn-sm mr-2"
								@click="setProductInventory(warehouse, 'edit')">
								<i class="material-icons btn-icon">edit</i>
							</button>
							<button
								v-tooltip="$t('Delete Warehouse')"
								class="btn bg-gray btn-light btn-sm"
								@click="setProductInventory(warehouse, 'delete')">
								<i class="material-icons btn-icon">delete</i>
							</button>
						</div>
					</div>
				</div>
			</template>
			<template #body>
				<div class="row">
					<div class="col-12 mt-4">
						<span>
							{{ $t('Inventory Stock Quantities') }}
						</span>
					</div>
					<!-- Variable -->
					<div v-if="type === 'variable'" class="col-12 mt-3">
						<div class="border">
							<div
								v-for="(value, i) in variantStock"
								:key="i"
								class="d-flex align-items-center justify-content-between p-2">
								<div>
									<span>{{ setNameVariant(value) }}</span>
									<!-- <span>{{ value.name.split('||').join(' - ') }}</span> -->
								</div>
								<div class="form-group">
									<div class="d-flex align-items-center">
										<div class="input-group">
											<!-- <input
												:value="value.quantity"
												:class="{
													disabled: isEditProduct && !isNewVariation(value.name),
												}"
												type="number"
												class="form-control bg-white"
												placeholder="0"
											/> -->
											<input
												type="number"
												class="input form-control disabled"
												min="0"
												:value="value.quantity"
												disabled
												@input="createNewVariation($event, value.name)"
											/>
											<div
												class="input-group-append"
												data-toggle="buttons"
											>
												<button
													v-for="(btn, i) in listAction"
													@click="openModalAction(btn.key, value)"
													v-tooltip="btn.text"
													:key="i"
													class="btn btn-actions">
													<i :class="`material-icons ${btn.class}`">
														{{ btn.icon }}
													</i>
												</button>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<!-- Simple -->
					<div v-if="type === 'simple'" class="col-12 mt-3">
						<div class="border">
							<div class="d-flex align-items-center justify-content-between p-3">
								<div>
									<span>Stock</span>
								</div>
								<div class="form-group">
									<div class="d-flex align-items-center">
										<div class="input-group">
											<input
												:value="warehouse.quantity"
												disabled
												type="number"
												class="form-control bg-white disabled"
												placeholder="0"
												@change="createNewVariation"
											/>
											<div
												class="input-group-append"
												data-toggle="buttons">
												<button
													v-for="(btn, i) in listAction"
													@click="openModalAction(btn.key, warehouse.quantity)"
													:key="i"
													class="btn btn-actions">
													<i :class="`material-icons ${btn.class}`">
														{{ btn.icon }}
													</i>
												</button>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</template>
		</Accordion>
	</div>
	<div v-else>
		<div class="p-4 border list-empty rounded">
			<i class="material-icons md-48 mr-2">error_outline</i><span>Tidak Ada Data.</span>
		</div>
	</div>
	<div class="modals">
		<warehouse-delete
			v-if="showDeleteModal"
			:warehouse="selected"
			@close="showDeleteModal = false"
			@set="setDeleteWarehouse"
		/>
		<warehouse-form
			:show="isWarehouseFormVisible"
			:selectedWarehouse="selected"
			:formType="typeForm"
			@set="setWarehouseEditData"
			@close="isWarehouseFormVisible = false"
		/>
		<update-stock
			v-if="showModalUpdateStock"
			:warehouse="productInventory"
			:type="typeModal"
			:stock="stock"
			:name="nameVariant"
			:variations="variations"
			:product="product"
			@close="showModalUpdateStock = false"
			@set-stock="setStokProductInventory"
		/>
	</div>
</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Accordion from '@/components/Accordion.vue';
import productInventoryApi from '@/api/product-inventory';
import WarehouseDelete from '@/components/products/new-inventory/section/modal/WarehouseDelete.vue';
import WarehouseForm from '@/components/WarehouseForm.vue';
import warehouseApi from '@/api/warehouse';
import UpdateStock from '@/components/products/new-inventory/section/modal/UpdateStock.vue';
import { duplicateVar, getAxiosErrorMessage, setMaximumStock } from '@/lib/helper';

const listAction = [
	{
		icon: 'edit_note',
		key: 'sync',
		text: 'Adjust Stock',
		class: 'text-primary',
	},
	{
		icon: 'add',
		key: 'increase',
		text: 'Add Stock',
		class: 'text-success',
	},
	{
		icon: 'remove',
		key: 'decrease',
		text: 'Reduce Stock',
		class: 'text-danger',
	},
];

export default {
	name: 'SectionListWarehouse',
	props: {
		product: {
			type: Object,
			required: true,
		},
		productId: {
			type: String,
			default: '',
		},
		isEditProduct: {
			type: Boolean,
			required: false,
		},
	},
	components: {
		Accordion,
		WarehouseForm,
		WarehouseDelete,
		UpdateStock,
	},
	data() {
		return {
			listAction,
			productInventories: [],
			showDeleteModal: false,
			selected: {},
			productInventory: {},
			mode: '',
			typeForm: '',
			allWarehouse: [],
			isWarehouseFormVisible: false,
			showModalUpdateStock: false,
			typeModal: '',
			stock: 0,
			nameVariant: '',
			maxLength: 7,
		};
	},
	computed: {
		...mapGetters({
			warehouse: 'productWarehouse/warehouse',
			type: 'productWarehouse/type',
			variants: 'productWarehouse/variants',
			variantStock: 'productWarehouse/variantStock',
			setting: 'productWarehouse/stock',
			productPrices: 'productWarehouse/productPrices',
			isAttributeAdded: 'productWarehouse/isAttributeAdded',
		}),
		variations() {
			const isVariableProduct = this.type === 'variable';
			// const variations = isVariableProduct ? generateCombinations(this.variants) : [];
			const variations = isVariableProduct ? this.productPrices : [];
			return variations;
		},
		listWarehouse() {
			const warehouse = this.warehouse.filter(
				curr => curr.warehouse_label !== ''
					&& curr.warehouse_label !== null
					&& curr.warehouse_label,
			);
			return warehouse.map(curr => ({
				...curr,
				showCard: false,
			}));
		},
	},
	watch: {},
	mounted() {
		this.fetch();
		this.getListAllWarehouse();
		this.fetchAttributeAdded();
	},
	methods: {
		...mapActions({
			setWarehouse: 'productWarehouse/setWarehouse',
			deleteWarehouse: 'productWarehouse/deleteWarehouse',
			editWarehouse: 'productWarehouse/editWarehouse',
			setVariantStock: 'productWarehouse/setVariantStock',
			updateListWarehouse: 'productWarehouse/updateListWarehouse',
			setStockProduct: 'productWarehouse/setStock',
			setAttributeAdded: 'productWarehouse/setAttributeAdded',
		}),
		fetchAttributeAdded() {
			if (this.isAttributeAdded) {
				this.fetch();
				this.getListAllWarehouse();
				this.setAttributeAdded(false);
			}
		},
		isInputAvalaible(variation) {
			return this.isEditProduct && !this.isNewVariation(variation.name);
		},
		setNameVariant(value) {
			return value.name.split('||').join(' - ');
		},
		setStokProductInventory(stock) {
			const indexWarehouse = this.listWarehouse.findIndex(curr => curr._id === stock._id);
			// eslint-disable-next-line camelcase
			const warehouse_label = this.listWarehouse[indexWarehouse].warehouse_label;
			if (this.type === 'variable') {
				if (indexWarehouse !== -1) {
					this.listWarehouse[indexWarehouse] = { ...stock, warehouse_label };
				}
			} else if (this.type === 'simple') {
				if (indexWarehouse !== -1) {
					this.listWarehouse[indexWarehouse] = { ...stock, warehouse_label };
					this.listWarehouse[indexWarehouse].quantity = stock.quantity;
					this.productInventory.quantity = stock.quantity;
				}
			}
		},
		getVariationName(variation) {
			const isArray = Array.isArray(variation);
			const variationName = isArray ? variation.join(' - ') : variation;
			return variationName;
		},
		fetch() {
			if (this.productId !== null) {
				const params = {
					product_id: this.productId,
				};
				const callback = (response) => {
					const inventories = response.data;
					this.productInventories = duplicateVar(inventories);
					this.setWarehouse(this.productInventories);
					this.isMultiWarehouseFetched = true;
					const productStock = this.product?.stock ?? null;
					const stock = duplicateVar(productStock);
					this.setStockProduct(stock);
				};
				const errorCallback = () => {};
				productInventoryApi.getList(params, callback, errorCallback);
			}
		},
		deleteData(data) {
			this.selected = data;
			this.showDeleteModal = true;
		},
		editDataWarehouse(data) {
			this.selected = data;
			this.typeForm = 'edit';
			this.isWarehouseFormVisible = true;
		},
		resetAccourdion(data) {
			const index = this.listWarehouse.findIndex(curr => curr._id === data._id);
			this.listWarehouse[index].showCard = !this.listWarehouse[index].showCard;
		},
		setProductInventory(productInventory, type = '') {
			if (type === 'delete') {
				this.deleteData(productInventory);
				this.resetAccourdion(productInventory);
			} else if (type === 'edit') {
				const selected = this.allWarehouse.find(
					curr => curr._id === productInventory.warehouse_id,
				);
				this.editDataWarehouse(selected);
				this.resetAccourdion(productInventory);
			} else {
				this.productInventory = productInventory;
				if (this.type === 'variable') {
					const savedVariations = {
						...productInventory,
						variations: productInventory.variations ?? [],
					};

					const mapper = (variation) => {
						const quantity = 0;
						return {
							name: variation.name,
							quantity,
						};
					};
					const productVariations = this.variations.map(mapper);
					const products = {
						...savedVariations,
						stockVariant: productVariations,
					};

					this.setVariantStock(products);
				}
			}
			this.setAttributeAdded(false);
		},
		setDeleteWarehouse(warehouseId) {
			const callback = () => {
				this.showDeleteModal = false;
				this.deleteWarehouse(warehouseId);
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Remove Product Inventory',
					text: 'Successfully remove product inventory',
				});
			};
			const err = (e) => {
				const message = getAxiosErrorMessage(e);
				this.isDeletingProductInventory = false;
				this.$notify({
					group: 'app',
					type: 'danger',
					title: 'Remove Product Inventory',
					text: message,
				});
			};
			productInventoryApi.remove(warehouseId, {}, callback, err);
		},
		openModalAction(key, stock) {
			this.typeModal = key;
			this.stock = stock?.quantity ?? 0;
			this.nameVariant = stock.name;
			this.showModalUpdateStock = true;
		},
		setWarehouseEditData(data) {
			this.editWarehouse(data);
		},
		getListAllWarehouse() {
			this.isFetching = true;
			const params = {
				page: 1,
				limit: 100,
				is_deleted: false,
			};
			const callback = (response) => {
				const warehouses = response.data;
				this.allWarehouse = warehouses;
				this.isFetching = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Warehouses',
					text: message,
				});
				this.isFetching = false;
			};
			warehouseApi.getWarehouses(params, callback, errorCallback);
		},
		isNewVariation(variationName) {
			// eslint-disable-next-line camelcase
			const prices = this.productInventory?.product_variations?.prices ?? [];
			const variations = prices.filter(price => price.name === variationName);
			const ret = variations.length === 0;
			return ret;
		},
		createNewVariation(event, name = '') {
			let value = event.target.value;
			const id = this.productInventory._id;
			if (Number.isNaN(parseInt(value))) {
				event.target.value = 1;
			} else if (value < 0) {
				event.target.value = 1;
			} else if (value >= 0 && value.length > this.maxLength) {
				event.target.value = setMaximumStock(value, this.maxLength);
			}

			value = event.target.value;
			const payload = {
				quantity: parseInt(value),
				type: 'sync',
				variation: name,
				description: '',
			};
			const callback = () => {
				this.$notify({
					group: 'app',
					text: 'Stock successfully updated.',
					type: 'success',
				});
			};

			const errorCallback = (e) => {
				console.log(e);
			};
			productInventoryApi.update(id, payload, callback, errorCallback);
		},
		isOpen(warehouse, productInventory) {
			let show = false;

			if (!!productInventory && warehouse._id === productInventory._id && !this.isAttributeAdded) {
				show = true;
			} else if (this.isAttributeAdded) {
				show = false;
			}

			return show;
		},
	},
};
</script>

<style lang="scss">
.product-cursor-disable {
	.accordion-header {
		cursor: not-allowed !important;
	}
}
</style>
